// extracted by mini-css-extract-plugin
module.exports = {"root":"+OwcS","input":"eB8jw","message":"OF2dP","label":"hY0Sz","inputWrapper":"SWcy3"};